/**
 * MOP 网关(ngw) 签名请求封装 —— 用于腾讯云 COS 上传所需的凭证接口
 *
 * 参考 kuguanjia-help/src/common/api/base.js。
 * 这两个接口仅用请求头 appKey + apiSign 签名，未登录也可访问：
 *   GET /crm-biz/a/oss/info/get    取 bucketName / regionName
 *   GET /crm-biz/a/oss/upload/sign 取 STS 临时密钥(tmpSecretId 等)
 */
import axios from 'axios';
import md5 from 'md5';

const APP_KEY = process.env.__MOP_APPKEY__;
const APP_PWD = process.env.__MOP_APPPWD__;
const API_URL = process.env.__MOP_HOSTURL__;

const service = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  },
});

// apiSign = md5(APP_PWD + 排序后的请求串 + APP_PWD)
function getApiSign(config) {
  let str;
  if (config.method === 'get') {
    const { params } = config;
    if (!params) {
      str = '';
    } else {
      str = Object.keys(params)
        .sort()
        .map((key) => `${key}=${params[key]}`)
        .join('&');
    }
  } else {
    str = JSON.stringify(config.data);
  }
  return md5(APP_PWD + str + APP_PWD);
}

service.interceptors.request.use(
  (config) => {
    config.headers.appKey = APP_KEY;
    config.headers.apiSign = getApiSign(config);
    return config;
  },
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code === 10000) {
      return res;
    }
    return Promise.reject(res);
  },
  (err) => Promise.reject(err),
);

export function getOssInfo() {
  return service.get('/crm-biz/a/oss/info/get');
}

export function getUploadSign(params) {
  return service.get('/crm-biz/a/oss/upload/sign', { params });
}

export default service;
